import { Button, Checkbox, Heading, Typography } from '@altify/components';

import { useContent } from '@altify/utils';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { useState } from 'react';
import smartTrade from '../../assets/smart-trade.png';
import { tradeSharedContent } from '../../tradeShared.content';
import { content } from './SmartTradeModal.content';

const SmartTradeModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose?: (dontShowAgain: boolean) => void;
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const localizedContent = useContent(content, tradeSharedContent);

  return (
    <DialogOrBottomSheet
      isOpen={isOpen}
      blurEnabled={true}
      onClose={() => onClose?.(false)}
      backgroundColor="#0C1C2C">
      <div className="flex flex-col items-center w-full my-4 px-4 gap-6">
        <img src={smartTrade} height={205} width={282} />
        <Heading level={4} className="text-center">
          {localizedContent.accessBestCryptoPrices}
        </Heading>
        <Typography
          size="large"
          weight="medium"
          className="text-gray text-center">
          {localizedContent.smartTradeDescription}
        </Typography>
        <Typography
          size="large"
          weight="medium"
          className="text-gray text-center">
          {localizedContent.investBetterDescription}
        </Typography>

        <div className="w-full flex flex-col items-center mt-10">
          <Checkbox
            label={localizedContent.dontShowAgain}
            onChange={setIsChecked}
          />

          <Button
            color="primary"
            size="large"
            onPress={() => onClose?.(isChecked)}
            text={localizedContent.iUnderstand}
            className="mt-6 mb-3 w-full"
          />
        </div>
      </div>
    </DialogOrBottomSheet>
  );
};

export default SmartTradeModal;
